// @flow

import React, { type Element } from 'react'

type FormData = {
  formId: string,
  resetPasswordToken: string,
  password: string,
}

const getCsrfToken = (): string => {
  const csrfTag: ?HTMLElement = document.querySelector("meta[name='csrf-token']")
  const csrfToken: ?string = csrfTag?.getAttribute('content')

  if (csrfToken === null) {
    const error = new Error('Unable to find csrf-token in the password reset page')
    window.newrelic.noticeError(error)
  }

  return csrfToken ?? ''
}

function HiddenForm({ formData }: { formData: FormData }): Element<'form'> {
  return (
    <form
      id={formData.formId}
      action="/users/password"
      acceptCharset="UTF-8"
      method="post"
      onSubmit={(e) => e.preventDefault()}
    >
      <input type="hidden" name="_method" value="put"></input>
      <input type="hidden" name="utf8" value="✓" />
      <input type="hidden" name="authenticity_token" value={getCsrfToken()} />
      <input
        type="hidden"
        name="user[reset_password_token]"
        id="user_reset_password_token"
        value={formData.resetPasswordToken}
      />
      <input type="hidden" name="user[password]" id="user_password" value={formData.password} />
      <input
        type="hidden"
        name="user[password_confirmation]"
        id="user_password_confirmation"
        value={formData.password}
      />
    </form>
  )
}

export default HiddenForm
